module.exports = __webpack_public_path__ + "img/247.417dd096.jpg";